export const genre_list = [
  "Movies",
  "Comedy",
  "Lifestyle",
  "Sports",
  "Education",
];

export const rating_list = ["7+", "12+", "16+", "18+"];

export const sort_options = ["Release Date", "View Count"];